import { NextContextProvider } from "@client/context/next";
import { type AppState } from "@client/types";
import { DEFAULT_DYNAMIC_REDUCERS } from "@client/viewer/reducers";
import { ClickOutsideContextProvider } from "@common/contexts/ClickOutside";
import { I18nContextProvider } from "@common/contexts/I18n";
import { ModalContextProvider } from "@common/contexts/Modal";
import { TooltipContextProvider } from "@common/contexts/Tooltip";
import type { WithChildren } from "@common/declarations";
import * as React from "react";
import { Provider } from "react-redux";
import { type AnyAction, type Store } from "redux";
import AppContextProvider from "../context/app";
import Page from "./Page";
import { createReducer } from "./reducers";

type Props = Partial<WithChildren> & {
  store: Store<AppState, AnyAction>;
};

export default (props: Props) => (
  // <React.StrictMode>
  <I18nContextProvider>
    <AppContextProvider theme="Day">
      <Provider store={props.store}>
        <NextContextProvider createReducer={createReducer} dynamicReducers={DEFAULT_DYNAMIC_REDUCERS}>
          <TooltipContextProvider>
            <ModalContextProvider>
              <ClickOutsideContextProvider>
                <Page>{props.children}</Page>
              </ClickOutsideContextProvider>
            </ModalContextProvider>
          </TooltipContextProvider>
        </NextContextProvider>
      </Provider>
    </AppContextProvider>
  </I18nContextProvider>
  // </React.StrictMode>
);
